import CommonFunctions from "./CommonFunctions";
import ContentDisposition from "./ContentDisposition";

/*
* jQuery File Download
*/
(($, window) => {

    function readableError(body: string, statusText: string): string {
        if (body) {
            try {
                const problem = JSON.parse(body);
                const message = problem?.detail || problem?.title;
                if (message) {
                    return message;
                }
            } catch {
                // Not JSON - an error page or plain text.
            }
        }
        return body || statusText;
    }

    $.extend({
        fileDownload(fileUrl, options) {
            const settings = $.extend({
                httpMethod: "POST",
                data: null,
                fileName: null,
                loadingTarget: null,
            }, options);

            // Whoever knows a smaller element than the page says so. The default stays the whole page,
            // because a download started from a toolbar has nothing meaningful to point at.
            const loadingTarget: JQuery = settings.loadingTarget && settings.loadingTarget.length ? settings.loadingTarget : $("body");

            const method: string = settings.httpMethod;
            // A GET or HEAD request must not carry a body, fetch rejects that outright, and without a
            // body the Content-Type header would only provoke a CORS preflight.
            const hasBody = method !== "GET" && method !== "HEAD";
            const request: RequestInit = {
                method,
                // The attachment download addresses the API on another origin, which still needs the
                // authentication cookie. Same-origin callers are unaffected by this.
                credentials: "include",
            };
            if (hasBody) {
                request.body = JSON.stringify(settings.data);
                request.headers = { "Content-Type": "application/json" };
            }

            CommonFunctions.isLoading(loadingTarget);
            fetch(fileUrl, request)
                .then(async (resp) => {
                    if (!resp.ok) {
                        const errorText = await resp.text(); // try to get the error text from the server.
                        throw new Error(readableError(errorText, resp.statusText));
                    }
                    let name = null;
                    try {
                        name = ContentDisposition.getFilenameFromContentDispositionHeader(resp.headers.get("content-disposition"));
                    } catch (e) {
                        console.warn(e);
                    }
                    // Cross-origin that header is not readable at all - it is not CORS-safelisted and the
                    // API exposes no extra headers - so a caller that knows the name supplies it.
                    return { data: resp.blob(), name: name || settings.fileName };
                }).then((data) => {
                    data.data.then((blob) => {
                        if (blob.size === 0) {
                            CommonFunctions.isLoadeded(loadingTarget);
                            return;
                        }
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.style.display = "none";
                        a.href = url;
                        if (data.name) {
                            a.download = data.name;
                        }
                        document.body.appendChild(a);
                        a.click();
                        setTimeout(() => {
                            window.URL.revokeObjectURL(url);
                            document.body.removeChild(a);
                        }, 1000);
                        CommonFunctions.isLoadeded(loadingTarget);
                        if (settings.successCallback) {
                            settings.successCallback(url);
                        }
                    }).catch((error) => {
                        CommonFunctions.isLoadeded(loadingTarget);
                        if (settings.failCallback) {
                            settings.failCallback(error.message || error);
                        }
                    });
                }).catch((error) => {
                    CommonFunctions.isLoadeded(loadingTarget);
                    if (settings.failCallback) {
                        settings.failCallback(error.message || error);
                    }
                });
        }
    });
})(jQuery, this || window);
